import { useContext, useSyncExternalStore } from 'react';
import { ReactReduxContext } from 'react-redux';
import type { RootState } from '../store/store';

/**
 * A safe version of useSelector that returns a fallback when no Redux Provider
 * is present (e.g., on the public marketing site).
 */
export function useSafeSelector<T>(
  selector: (state: RootState) => T,
  fallback: T
): T {
  const context = useContext(ReactReduxContext);
  const store = context?.store;

  return useSyncExternalStore(
    (onStoreChange) => {
      if (!store) return () => {};
      return store.subscribe(onStoreChange);
    },
    () => (store ? selector(store.getState() as RootState) : fallback),
    () => fallback
  );
}
